import React, { FC } from 'react';
import Tippy, { TippyProps } from '@tippyjs/react';
import { followCursor } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import styled from 'styled-components';
import constants from '../common/theme/constants';

const StyledTippy = styled(Tippy)`
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-weight: ${constants.fontWeight.normal};
  font-size: ${constants.fontSize.text_14}rem;
  box-sizing: border-box;
`;

// this plugin is needed to hide tooltip on esc when element is focused
const hideOnEsc = {
  name: 'hideOnEsc',
  defaultValue: true,
  fn({ hide }) {
    function onKeyDown(event) {
      if (event.keyCode === 27) {
        hide();
      }
    }

    return {
      onShow() {
        document.addEventListener('keydown', onKeyDown);
      },
      onHide() {
        document.removeEventListener('keydown', onKeyDown);
      },
    };
  },
};

const KitTips: FC<TippyProps> = (props: TippyProps) => {
  const { children } = props;
  return (
    <StyledTippy
      followCursor
      plugins={[followCursor, hideOnEsc]}
      placement='bottom'
      offset={[0, 25]}
      {...props}
    >
      {children}
    </StyledTippy>
  );
};

export default KitTips;
